import request from '../../../api/request';
import {
  ChildrenSearchQuery,
  ChildrenSearchResponse,
  CourseGroupDetail,
  CourseGroupListQuery,
  CourseGroupListResponse,
  CourseGroupParentsResponse,
  CreateCourseGroupBody,
  SetItemsBody,
  UpdateCourseGroupBody,
} from './types';

export const CG = {
  LIST: () => '/maintainers-portal/academic-offer/course-groups',
  DETAIL: (id: number | string) =>
    `/maintainers-portal/academic-offer/course-groups/${id}`,
  CREATE: () => '/maintainers-portal/academic-offer/course-groups',
  UPDATE: (id: number | string) =>
    `/maintainers-portal/academic-offer/course-groups/${id}`,
  DELETE: (id: number | string) =>
    `/maintainers-portal/academic-offer/course-groups/${id}`,
  PARENTS: (id: number | string) =>
    `/maintainers-portal/academic-offer/course-groups/${id}/parents`,
  SET_ITEMS: (id: number | string) =>
    `/maintainers-portal/academic-offer/course-groups/${id}/items`,
  CHILDREN_SEARCH: (id: number | string) =>
    `/maintainers-portal/academic-offer/course-groups/${id}/children-search`,
};

// HU 15571 — endpoint reutilizado del módulo de Asignaturas para obtener los
// planes de estudio (mallas) que poblará el filtro PLAN DE ESTUDIO del
// buscador de items. Sólo nos interesa la lista `studyPlanVersions`.
export const COURSES_FORM_DATA_PATH =
  '/maintainers-portal/academic-offer/curricular-subjects/form-data';

export interface StudyPlanVersionItem {
  id: number;
  name: string;
}

export interface CoursesFormDataResponse {
  studyPlanVersions: StudyPlanVersionItem[];
}

export function getCourseGroupsListRequest(params: CourseGroupListQuery) {
  return request<CourseGroupListResponse>(CG.LIST(), { params });
}

export function getCourseGroupDetailRequest(id: number | string) {
  return request<CourseGroupDetail>(CG.DETAIL(id));
}

export function createCourseGroupRequest(data: CreateCourseGroupBody) {
  return request<CourseGroupDetail>(CG.CREATE(), {
    method: 'POST',
    data,
  });
}

export function updateCourseGroupRequest(
  id: number | string,
  data: UpdateCourseGroupBody,
) {
  return request<CourseGroupDetail>(CG.UPDATE(id), {
    method: 'PATCH',
    data,
  });
}

export function deleteCourseGroupRequest(id: number | string) {
  return request<void>(CG.DELETE(id), { method: 'DELETE' });
}

export function getCourseGroupParentsRequest(id: number | string) {
  return request<CourseGroupParentsResponse>(CG.PARENTS(id));
}

export function setCourseGroupItemsRequest(
  id: number | string,
  data: SetItemsBody,
) {
  return request<CourseGroupDetail>(CG.SET_ITEMS(id), {
    method: 'PATCH',
    data,
  });
}

export function searchCourseGroupChildrenRequest(
  id: number | string,
  params: ChildrenSearchQuery,
) {
  return request<ChildrenSearchResponse>(CG.CHILDREN_SEARCH(id), { params });
}

export function getCoursesFormDataRequest() {
  return request<CoursesFormDataResponse>(COURSES_FORM_DATA_PATH);
}
